import {HttpEvent, HttpEventType} from '@angular/common/http';
import {EpgDownloadCenterService} from './epg-download-center.service';

export function epgDownloadProgressTrack(
  event: HttpEvent<any>,
  downloadCenterService: EpgDownloadCenterService,
) {
  switch (event.type) {
    case HttpEventType.DownloadProgress:
      downloadCenterService.downloadState.update((state) => ({
        ...state,
        downloading: true,
        progress: 0,
        error: null,
      }));
      break;
    case HttpEventType.Response:
      downloadCenterService.downloadState.update((state) => ({
        ...state,
        downloading: false,
        progress: 100,
        error: null,
        isCompleted: true,
      }));

      setTimeout(() => {
        downloadCenterService.downloadState.update((state) => ({
          ...state,
          downloading: false,
          progress: 0,
          error: null,
          isCompleted: false,
        }));
      }, 5000);
      break;
  }
}
